/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";

// This hook skips initial mount effect call and call callback on every dependency update

const useDidUpdateEffect = (effectCallback: () => void, dependencies: any[]): void => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      effectCallback();
    }
    didMountRef.current = true;
  }, dependencies);
};

export default useDidUpdateEffect;
